const Config = {
  baseURL: 'https://smartcardnfc.com',
  MEDIA_URL: 'https://smartcardnfc.com',
};

export default Config;


